// account
export const SIGNUP_URL = '/auth/signup';
export const SIGNUP_OAUTH_URL = '/auth/signupOAuth';
export const LOGIN_URL = '/auth/login';
export const LOGIN_OAUTH_URL = '/auth/loginOAuth';
export const LOGOUT_URL = '/auth/logout';
export const RECORD_EXPORT_URL = '/activityLog/export';
export const FORGOT_PASSWORD_URL = '/auth/forgotPassword';
export const RESET_PASSWORD = '/auth/resetPassword';
export const RESET_PASSWORD_AUTHED_URL = '/auth/resetPasswordAuthed';
export const SET_PASSWORD_AND_VERIFY_URL = '/auth/setPasswordAndVerify';
export const REQUEST_SET_PASSWORD_AND_VERIFY_URL =
  '/auth/requestSetPasswordAndVerifyLink';
export const REQUEST_EMAIL_VERIFICATION = '/auth/requestEmailVerificationLink';
export const VERIFY_EMAIL_URL = '/auth/verifyEmail';

// user
export const GET_USER_URL = '/user';
export const REGISTER_USER_URL = '/user';
export const EDIT_USER_URL = '/user';
export const TOGGLE_USER_IS_ACTIVE_URL = '/user/isActive';
export const DELETE_USER_URL = '/user';

// organization
export const GET_ORGANIZATION_URL = '/organization';
export const GET_ORGANIZATION_STATS_URL = '/organization/stats';
export const REGISTER_ORGANIZATION_URL = '/organization';
export const SIGNUP_ORGANIZATION_URL = '/organization/signup';
export const EDIT_ORGANIZATION_URL = '/organization';
export const TOGGLE_ORGANIZATION_IS_ACTIVE_URL = '/organization/isActive';
export const DELETE_ORGANIZATION_URL = '/organization';

// donation
export const GET_DONATION_URL = '/donation';
export const REGISTER_DONATION_URL = '/donation';
export const EDIT_DONATION_URL = '/donation';
export const TOGGLE_DONATION_IS_ACTIVE_URL = '/donation/isActive';
export const MOVE_DONATION_TO_FOLDER_URL = '/donation/folder';
export const BULK_MOVE_DONATIONS_TO_FOLDER_URL = '/donation/bulk/folder';
export const DELETE_DONATION_URL = '/donation';
export const BULK_DELETE_DONATIONS_URL = '/donation/bulk';

// folder
export const GET_FOLDER_URL = '/folder';
export const REGISTER_FOLDER_URL = '/folder';
export const EDIT_FOLDER_URL = '/folder';
export const DELETE_FOLDER_URL = '/folder';

// announcement
export const GET_ANNOUNCEMENT_URL = '/announcement';
export const REGISTER_ANNOUNCEMENT_URL = '/announcement';
export const EDIT_ANNOUNCEMENT_URL = '/announcement';
export const TOGGLE_ANNOUNCEMENT_IS_ACTIVE_URL = '/announcement/isActive';
export const MOVE_ANNOUNCEMENT_TO_FOLDER_URL = '/announcement/folder';
export const BULK_MOVE_ANNOUNCEMENTS_TO_FOLDER_URL = '/announcement/bulk/folder';
export const DELETE_ANNOUNCEMENT_URL = '/announcement';
export const BULK_DELETE_ANNOUNCEMENTS_URL = '/announcement/bulk';

// shiurei torah
export const GET_SHIUREI_TORAH_URL = '/shiurei_torah';
export const REGISTER_SHIUREI_TORAH_URL = '/shiurei_torah';
export const EDIT_SHIUREI_TORAH_URL = '/shiurei_torah';
export const TOGGLE_SHIUREI_TORAH_IS_ACTIVE_URL = '/shiurei_torah/isActive';
export const MOVE_SHIUREI_TORAH_TO_FOLDER_URL = '/shiurei_torah/folder';
export const BULK_MOVE_SHIUREI_TORAHS_TO_FOLDER_URL = '/shiurei_torah/bulk/folder';
export const DELETE_SHIUREI_TORAH_URL = '/shiurei_torah';
export const BULK_DELETE_SHIUREI_TORAHS_URL = '/shiurei_torah/bulk';

// template
export const GET_TEMPLATE_URL = '/template';
export const REGISTER_TEMPLATE_URL = '/template';
export const EDIT_TEMPLATE_URL = '/template';
export const TOGGLE_TEMPLATE_IS_ACTIVE_URL = '/template/isActive';
export const DELETE_TEMPLATE_URL = '/template';

// shiurei torah template
export const GET_SHIUREI_TORAH_TEMPLATE_URL = '/shiurei_torah_template';
export const REGISTER_SHIUREI_TORAH_TEMPLATE_URL = '/shiurei_torah_template';
export const EDIT_SHIUREI_TORAH_TEMPLATE_URL = '/shiurei_torah_template';
export const TOGGLE_SHIUREI_TORAH_TEMPLATE_IS_ACTIVE_URL = '/shiurei_torah_template/isActive';
export const DELETE_SHIUREI_TORAH_TEMPLATE_URL = '/shiurei_torah_template';

// screen
export const GET_SCREEN_URL = '/screen';
export const GET_SCREEN_UNPOPULATED_URL = '/screen/unpopulated';
export const REGISTER_SCREEN_URL = '/screen';
export const REFRESH_SCREEN_URL = '/screen/refresh';
export const EDIT_SCREEN_URL = '/screen';
export const TOGGLE_SCREEN_IS_ACTIVE_URL = '/screen/isActive';
export const DELETE_SCREEN_URL = '/screen';

// screen_schedule — switching schedules and the public link that plays them
export const SCREEN_SCHEDULE_URL = '/screenSchedule';
export const SCREEN_SCHEDULE_BY_SCREEN_URL = '/screenSchedule/screen';
export const PUBLIC_SCREEN_SCHEDULE_URL = '/screenSchedule/public';

// screen_artboard
export const GET_SCREEN_ARTBOARD_URL = '/screenArtboard';
export const GET_SCREEN_ARTBOARD_CONTENT_URL = '/screenArtboard/content';
export const REGISTER_SCREEN_ARTBOARD_URL = '/screenArtboard';
export const EDIT_SCREEN_ARTBOARD_URL = '/screenArtboard';
export const TOGGLE_SCREEN_ARTBOARD_IS_ACTIVE_URL = '/screenArtboard/isActive';
export const DELETE_SCREEN_ARTBOARD_URL = '/screenArtboard';

// member
export const GET_MEMBER_URL = '/member';
export const REGISTER_MEMBER_URL = '/member';
export const EDIT_MEMBER_URL = '/member';
export const TOGGLE_MEMBER_IS_ACTIVE_URL = '/member/isActive';
export const DELETE_MEMBER_URL = '/member';

// minyanim
export const GET_MINYANIM_URL = '/minyanim';
export const REGISTER_MINYANIM_URL = '/minyanim';
export const EDIT_MINYANIM_URL = '/minyanim';
export const SYNC_MINYANIM_URL = '/minyanim/sync';
export const TOGGLE_MINYANIM_IS_ACTIVE_URL = '/minyanim/isActive';
export const DELETE_MINYANIM_URL = '/minyanim';

// minyanim_type
export const GET_MINYANIM_TYPE_URL = '/minyanimType';
export const REGISTER_MINYANIM_TYPE_URL = '/minyanimType';
export const EDIT_MINYANIM_TYPE_URL = '/minyanimType';
export const TOGGLE_MINYANIM_TYPE_IS_ACTIVE_URL = '/minyanimType/isActive';
export const DELETE_MINYANIM_TYPE_URL = '/minyanimType';

// minyanim_countdown
export const GET_MINYANIM_COUNTDOWN_URL = '/minyanimCountdown';
export const REGISTER_MINYANIM_COUNTDOWN_URL = '/minyanimCountdown';
export const EDIT_MINYANIM_COUNTDOWN_URL = '/minyanimCountdown';
export const TOGGLE_MINYANIM_COUNTDOWN_IS_ACTIVE_URL = '/minyanimCountdown/isActive';
export const DELETE_MINYANIM_COUNTDOWN_URL = '/minyanimCountdown';

// room
export const GET_ROOM_URL = '/room';
export const REGISTER_ROOM_URL = '/room';
export const EDIT_ROOM_URL = '/room';
export const TOGGLE_ROOM_IS_ACTIVE_URL = '/room/isActive';
export const DELETE_ROOM_URL = '/room';

// zmanim
export const GET_ZMANIM_URL = '/zmanim';
export const REGISTER_ZMANIM_URL = '/zmanim';
export const EDIT_ZMANIM_URL = '/zmanim';
export const TOGGLE_ZMANIM_IS_ACTIVE_URL = '/zmanim/isActive';
export const DELETE_ZMANIM_URL = '/zmanim';

// event
export const GET_EVENT_URL = '/event';
export const REGISTER_EVENT_URL = '/event';
export const EDIT_EVENT_URL = '/event';
export const TOGGLE_EVENT_IS_ACTIVE_URL = '/event/isActive';
export const DELETE_EVENT_URL = '/event';

// ticket
export const TICKET_URL = '/ticket'
export const ADD_TICKET_URL = '/ticket/add'
export const EDIT_TICKET_URL = '/ticket/edit'
export const CLOSE_TICKET_URL = '/ticket/close'
export const DELETE_TICKET_URL = '/ticket'
export const TICKET_UNREAD_URL = '/ticket/unread'

// ticket_comment
export const TICKET_COMMENT_URL = '/ticketComment'
export const ADD_TICKET_COMMENT_URL = '/ticketComment/add'
export const EDIT_TICKET_COMMENT_URL = '/ticketComment/edit'
export const DELETE_TICKET_COMMENT_URL = '/ticketComment'

// date_time_banner
export const GET_DATE_TIME_BANNER_URL = '/dateTimeBanner';
export const REGISTER_DATE_TIME_BANNER_URL = '/dateTimeBanner';
export const EDIT_DATE_TIME_BANNER_URL = '/dateTimeBanner';
export const TOGGLE_DATE_TIME_BANNER_IS_ACTIVE_URL = '/dateTimeBanner/isActive';
export const DELETE_DATE_TIME_BANNER_URL = '/dateTimeBanner';

// poster
export const GET_POSTER_URL = '/poster';
export const REGISTER_POSTER_URL = '/poster';
export const EDIT_POSTER_URL = '/poster';
export const TOGGLE_POSTER_IS_ACTIVE_URL = '/poster/isActive';
export const DELETE_POSTER_URL = '/poster';

// api_token
export const GET_API_KEY_URL = '/apiKey';
export const REGISTER_API_KEY_URL = '/apiKey';
export const EDIT_API_KEY_URL = '/apiKey';
export const TOGGLE_API_KEY_IS_ACTIVE_URL = '/apiKey/isActive';
export const DELETE_API_KEY_URL = '/apiKey';

// minyan_roll_N
export const GET_MINYAN_ROLL_N_URL = '/minyanRoll_N';
export const REGISTER_MINYAN_ROLL_N_URL = '/minyanRoll_N';
export const EDIT_MINYAN_ROLL_N_URL = '/minyanRoll_N';
export const TOGGLE_MINYAN_ROLL_N_IS_ACTIVE_URL = '/minyanRoll_N/isActive';
export const MOVE_MINYAN_ROLL_N_TO_FOLDER_URL = '/minyanRoll_N/folder';
export const DELETE_MINYAN_ROLL_N_URL = '/minyanRoll_N';

// zmanim_N
export const GET_ZMANIM_N_URL = '/zmanim_N';
export const REGISTER_ZMANIM_N_URL = '/zmanim_N';
export const EDIT_ZMANIM_N_URL = '/zmanim_N';
export const TOGGLE_ZMANIM_N_IS_ACTIVE_URL = '/zmanim_N/isActive';
export const DELETE_ZMANIM_N_URL = '/zmanim_N';

// zmanim_display_override_N
export const GET_ZMANIM_DISPLAY_OVERRIDE_N_URL = '/zmanimDisplayOverride_N';
export const REGISTER_ZMANIM_DISPLAY_OVERRIDE_N_URL = '/zmanimDisplayOverride_N';
export const EDIT_ZMANIM_DISPLAY_OVERRIDE_N_URL = '/zmanimDisplayOverride_N';
export const TOGGLE_ZMANIM_DISPLAY_OVERRIDE_N_IS_ACTIVE_URL = '/zmanimDisplayOverride_N/isActive';
export const DELETE_ZMANIM_DISPLAY_OVERRIDE_N_URL = '/zmanimDisplayOverride_N';

// minyan_N
export const GET_MINYAN_N_URL = '/minyan_N';
export const REGISTER_MINYAN_N_URL = '/minyan_N';
export const EDIT_MINYAN_N_URL = '/minyan_N';
export const TOGGLE_MINYAN_N_IS_ACTIVE_URL = '/minyan_N/isActive';
export const DELETE_MINYAN_N_URL = '/minyan_N';

// custom_font
export const GET_CUSTOM_FONT_URL = '/customFont';
export const REGISTER_CUSTOM_FONT_URL = '/customFont';
export const EDIT_CUSTOM_FONT_URL = '/customFont';
export const DELETE_CUSTOM_FONT_URL = '/customFont';

// kabbalah_N
export const GET_KABBALAH_N_URL = '/kabbalah_N';
export const GET_KABBALAH_N_STATS_URL = '/kabbalah_N/stats';
export const GET_KABBALAH_N_DISPLAY_URL = '/kabbalah_N/display';
export const REGISTER_KABBALAH_N_URL = '/kabbalah_N';
export const SUBMIT_PUBLIC_KABBALAH_N_URL = '/kabbalah_N/public';
export const EDIT_KABBALAH_N_URL = '/kabbalah_N';
export const TOGGLE_KABBALAH_N_IS_ACTIVE_URL = '/kabbalah_N/isActive';
export const APPROVE_KABBALAH_N_URL = '/kabbalah_N/approve';
export const REJECT_KABBALAH_N_URL = '/kabbalah_N/reject';
export const MARK_VIEWED_KABBALAH_N_URL = '/kabbalah_N/viewed';
export const DELETE_KABBALAH_N_URL = '/kabbalah_N';

// kabbalah_design_N
export const GET_KABBALAH_DESIGN_N_URL = '/kabbalahDesign_N';
export const SAVE_KABBALAH_DESIGN_N_URL = '/kabbalahDesign_N';
export const UPLOAD_KABBALAH_DESIGN_IMAGE_N_URL = '/kabbalahDesign_N/image';

// organization — the org-wide Kabbalah display destination
export const EDIT_KABBALAH_DISPLAY_URL = '/organization/kabbalah-display';
